import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import StickerForm from './StickerForm';

const StickerEdit = () => {
	const { t, i18n } = useTranslation();
    const lang = i18n.language;
    const event = useSelector(state => state.event);
    const sticker = useSelector(state => state.sticker);

    return (
		<div>
	    	<h1>{t('sticker.edittitle')}</h1>
            <p>{t('sticker.editsubtitle') + event.name[lang]}</p>
            <StickerForm event={event} sticker={sticker}/>
		</div>
	);
};

export default StickerEdit;
